import { CRMListingEmbargoBanner } from "../../components/CRMListingEmbargoBanner/CRMListingEmbargoBanner";
import React from "react";
import { C as State } from "./../../state/State";
import { TDispatch } from "./../../state/TDispatch";
import { CRMPadding } from "../../components/Simple/CRMPadding/CRMPadding";
import { CRMListingAddressForm } from "./../../components/CRMListingAddressForm/CRMListingAddressForm";
import { CRMSpacingColumn } from "./../../components/CRMSpacingColumn/CRMSpacingColumn";
import { CRMCardOutside } from "./../../components/CRMCardOutside/CRMCardOutside";
import { CRMListingSpecificsForm } from "./../../components/CRMListingSpecificsForm/CRMListingSpecificsForm";
import { CRMListingPriceAndCostsForm } from "./../../components/CRMListingPriceAndCostsForm/CRMListingPriceAndCostsForm";
import { CRMListingSellingProcessForm } from "./../../components/CRMListingSellingProcessForm/CRMListingSellingProcessForm";
import { CRMListingCompetingAgentForm } from "./../../components/CRMListingCompetingAgentForm/CRMListingCompetingAgentForm";
import { CRMListingAppointedAgentForm } from "../../components/CRMListingAppointedAgentForm/CRMListingAppointedAgentForm";
import { CRMListingConveyancingForm } from "./../../components/CRMListingConveyancingForm/CRMListingConveyancingForm";
import { CRMListingFormSections, TCRMListingFormSections } from "../../models/CRMFormSections";
import { SpacingColumn } from "../../components/BuildingBlocks/SpacingColumn";
import { CRMSpacing } from "../../models/CRMSpacing";
import { CRMTitleSubSection } from "../../components/CRMTitleSubSection/CRMTitleSubSection";
import { CRMSailHomesAdHocTasksCard } from "../../components/CRMSailHomesAdHocTasksCard/CRMSailHomesAdHocTasksCard";
import { SpacingRow } from "../../components/BuildingBlocks/SpacingRow";
import { CRMListingFileUpload } from "../../components/CRMListingFileUpload/CRMListingFileUpload";
import CRMListingKeyManagementForm from "../CRMListingKeyManagementForm/CRMListingKeyManagementForm";
import { CRMListingDocumentManagementsForm } from "../../components/CRMListingDocumentManagementsForm/CRMListingDocumentManagementsForm";
import { CRMListingMarketingFormContainer } from "../CRMListingMarketingFormContainer/CRMListingMarketingFormContainer";
import { CRMListingSignsContainer } from "../CRMListingSignsContainer/CRMListingSignsContainer";
import { CRMLink } from "../../components/CRMLink/CRMLink";
import { WeightBold } from "../../components/WeightBold/WeightBold";
import { Routes } from "../../state/router/routerRoutes";
import { FontSignikaNegative } from "../../components/BuildingBlocks/FontSignikaNegative";
import { Uppercase } from "../../components/Uppercase/Uppercase";
import { Text } from "../../components/BuildingBlocks/Text";
import { CRMFontSizes } from "../../models/CRMFontSizes";
import { CRMListingIntroducerRefNotesCard } from "../../components/CRMListingIntroducerRefNotesCard/CRMListingIntroducerRefNotesCard";
import { CRMListingRoadblocksContainer } from "../CRMListingRoadblocksContainer/CRMListingRoadblocksContainer";

type TListingPagePrepContainerProps = {
    state: State<Routes>;
    dispatch: TDispatch;
};

export const CRMListingPagePrepContainer = (props: TListingPagePrepContainerProps): JSX.Element => {

    const isDetailsSectionSelected = (section: TCRMListingFormSections[number]): boolean => 
        CRMListingFormSections.isDetailsSectionSelected(
            props.state.routes.queryParams.VIEW_CRM_LISTING.visible_sections,
            section,
        );
    
    const introducerRef = () => props.state.forms.listing_page.data.output.read_only.introducer_external_reference_id;
    const introducerNotes = () => props.state.forms.listing_page.data.output.read_only.introducer_notes;

    return (
        <SpacingColumn spacing={CRMSpacing.LARGE}>
        <CRMListingEmbargoBanner
            doNotContactUntil={props.state.forms.listing_page.data.output.read_only.do_not_contact_until}
        />
        <SpacingRow spacing={CRMSpacing.X_LARGE} childSize="1fr 2fr" alignItems="flex-start">
            {/* COLUMN - FORM */}
            <SpacingColumn spacing={CRMSpacing.LARGE}>
                <CRMSailHomesAdHocTasksCard
                    addNewTaskFormStatus={props.state.forms.listing_page.create_ad_hoc_task.status}
                    assignableUsers={props.state.forms.listing_page.data.output.adhoc_assignable_users}
                    tasks={props.state.forms.listing_page.data.output.ad_hoc_tasks.filter((task) => task.original.section === "prep")}
                    onUpdateTasks={(payload) => props.dispatch({
                        type: "LISTING_PAGE_UPDATE_AD_HOC_TASKS",
                        payload,
                    })}
                    onAddNewTask={(task, deferred_date, assigned_to) => props.dispatch({
                        type: "LISTING_PAGE_ADD_AD_HOC_TASK",
                        payload: {
                            task,
                            listing_id: props.state.forms.listing_page.data.output.form.original.id,
                            section: "prep",
                            deferred_date,
                            assigned_to,
                        }
                    })}
                />

                <CRMCardOutside
                    borderRounding="right"
                    shadow={true}
                >
                    <CRMPadding size="large">
                        <CRMSpacingColumn spacing="large">
                            {isDetailsSectionSelected("address") && 
                                <CRMListingAddressForm
                                    listingForm={props.state.forms.listing_page.data.output.form}
                                    onChange={(form) => props.dispatch({
                                        type: "LISTING_PREPARATION_FORM_CHANGE",
                                        payload: form
                                    })}
                                />
                            }
                            {isDetailsSectionSelected("price_and_costs") && 
                                <CRMListingPriceAndCostsForm
                                    listingForm={props.state.forms.listing_page.data.output.form}
                                    onChange={(form) => props.dispatch({
                                        type: "LISTING_PREPARATION_FORM_CHANGE",
                                        payload: form
                                    })}
                                />
                            }
                            {isDetailsSectionSelected("specifics") && 
                                <CRMListingSpecificsForm
                                    listingPageData={props.state.forms.listing_page.data}
                                    onChange={(form) => props.dispatch({
                                        type: "LISTING_PREPARATION_FORM_CHANGE",
                                        payload: form
                                    })}
                                />
                            }
                            {isDetailsSectionSelected("marketing") && 
                                <CRMListingMarketingFormContainer
                                    {...props}
                                />
                            }
                            
                            {isDetailsSectionSelected("signs") && 
                                <CRMListingSignsContainer
                                    {...props}
                                />
                            }
                            
                            {isDetailsSectionSelected("documents") &&
                                <>
                                    <CRMListingDocumentManagementsForm
                                        listingForm={props.state.forms.listing_page.data.output.form}
                                        listingReadOnly={props.state.forms.listing_page.data.output.read_only}
                                        onChange={(form) => props.dispatch({
                                            type: "LISTING_PREPARATION_FORM_CHANGE",
                                            payload: form
                                        })}
                                    />
                                    <SpacingColumn spacing={CRMSpacing.MEDIUM}>
                                        <CRMTitleSubSection>
                                            Documents
                                        </CRMTitleSubSection>
                                        <CRMLink
                                            href="https://find-energy-certificate.digital.communities.gov.uk/"
                                            linkStyle="normal"
                                            target="_blank"
                                        >
                                            <WeightBold>Open EPC Register (in new tab)</WeightBold>
                                        </CRMLink>
                                        <CRMListingFileUpload
                                            listingId={props.state.forms.listing_page.data.output.form.original.id}
                                            listingStatus={props.state.forms.listing_page.data.output.read_only.status}
                                            files={props.state.forms.listing_page.data.output.read_only.documents}
                                            onUpload={(file) => {
                                                return props.dispatch({
                                                    type: "LISTING_PAGE_ADD_DOCUMENTS",
                                                    payload: file
                                                });
                                            }}
                                            onRemove={(file) => {
                                                return props.dispatch({
                                                    type: "LISTING_PAGE_REMOVE_DOCUMENT",
                                                    payload: file
                                                });
                                            }}
                                            onUpdate={(form) => {
                                                return props.dispatch({
                                                    type: "LISTING_PAGE_UPDATE_DOCUMENT",
                                                    payload: form
                                                });
                                            }}
                                        />
                                    </SpacingColumn>
                                </>
                            }
                            {isDetailsSectionSelected("selling_process") &&
                                <CRMListingSellingProcessForm
                                    listingPageData={props.state.forms.listing_page.data}
                                    visibleSections={props.state.routes.queryParams.VIEW_CRM_LISTING.visible_sections}
                                    roadblocks={props.state.forms.listing_page.roadblocks.children.roadblocks}
                                    roadblocksStatus={props.state.forms.listing_page.roadblocks.status}
                                    onLoadRoadblocks={(listingId) => props.dispatch({ type: "LISTING_PAGE_GET_ROADBLOCKS", payload: listingId })}
                                    onTakeLive={(payload) => props.dispatch({ type: "LISTING_PAGE_TAKE_LIVE", payload })}
                                    onChange={(form) => props.dispatch({
                                        type: "LISTING_PREPARATION_FORM_CHANGE",
                                        payload: form
                                    })}
                                />
                            }
                            {isDetailsSectionSelected("appointed_agent") &&
                                <CRMListingAppointedAgentForm
                                    listingPageData={props.state.forms.listing_page.data}
                                    onChange={(form) => props.dispatch({
                                        type: "LISTING_PREPARATION_FORM_CHANGE",
                                        payload: form,
                                    })}
                                />
                            }
                            {isDetailsSectionSelected("competing_agent") &&
                                <CRMListingCompetingAgentForm
                                    listingForm={props.state.forms.listing_page.data.output.form}
                                    onChange={(form) => props.dispatch({
                                        type: "LISTING_PREPARATION_FORM_CHANGE",
                                        payload: form
                                    })}
                                />
                            }
                            {isDetailsSectionSelected("conveyancing") && 
                                <CRMListingConveyancingForm
                                    listingForm={props.state.forms.listing_page.data.output.form}
                                    onChange={(form) => props.dispatch({
                                        type: "LISTING_PREPARATION_FORM_CHANGE",
                                        payload: form
                                    })}
                                />
                            }
                            {isDetailsSectionSelected("key_management") && 
                                <CRMListingKeyManagementForm
                                    listingPageData={props.state.forms.listing_page.data}
                                    onChange={(form) => props.dispatch({
                                        type: "LISTING_PREPARATION_FORM_CHANGE",
                                        payload: form
                                    })}
                                />
                            }
                        </CRMSpacingColumn>
                    </CRMPadding>
                </CRMCardOutside>
            </SpacingColumn>
                            
            {/* COLUMN - SIDEBAR */}
            <SpacingColumn spacing={CRMSpacing.LARGE}>
                {/* ROADBLOCKS */}
                <CRMListingRoadblocksContainer
                    state={props.state}
                    dispatch={props.dispatch}
                />

                {/* INTRODUCER DETAILS */}
                {(introducerRef() !== "" || introducerNotes() !== "") &&
                    <SpacingColumn spacing={CRMSpacing.MEDIUM}>
                        {/* Title */}
                        <FontSignikaNegative>
                            <Text size={CRMFontSizes.LARGE}>
                                <WeightBold>
                                    <Uppercase>
                                        Introducer Details
                                    </Uppercase>
                                </WeightBold>
                            </Text>
                        </FontSignikaNegative>

                        <CRMListingIntroducerRefNotesCard
                            introducerRef={introducerRef()}
                            introducerNotes={introducerNotes()}
                            dateOfDeath={props.state.forms.listing_page.data.output.form.edited.date_of_death || undefined}
                        />
                    </SpacingColumn>
                }

            </SpacingColumn>
        </SpacingRow>
        </SpacingColumn>
    );
};
